import { render, staticRenderFns } from "./accountRegistrationComplete.vue?vue&type=template&id=060702b0&"
import script from "./accountRegistrationComplete.vue?vue&type=script&lang=js&"
export * from "./accountRegistrationComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports